import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IntercomService } from '@core/providers/backend/intercom.service';
import { AI_DISCLOSURE_ARTICLE_ID } from '@shared/components/ai-disclosure/ai-disclosure.constants';

/**
 * Compact upsell shown when an action needs Foodback Intelligence the account
 * doesn't have. Surfaced as a hover popover by AiUpsellPopoverDirective.
 */
@Component({
  selector: 'app-ai-upsell-popover',
  template: `
    <div class="ai-upsell-popover" role="note">
      <div class="ai-upsell-popover__badge">
        <span class="ai-upsell-popover__icon" aria-hidden="true"></span>
        <span>{{ 'SHARED.COMPONENTS.AI_TEASER.FI_BADGE' | translate }}</span>
      </div>
      <p class="ai-upsell-popover__text">
        {{ 'SHARED.TRANSLATE_DIALOG.AI_REQUIRES_INTELLIGENCE' | translate }}
      </p>
      <p class="ai-upsell-popover__detail">
        {{ 'SHARED.TRANSLATE_DIALOG.AI_UPSELL_DETAIL' | translate }}
      </p>
      <a href="#" class="ai-upsell-popover__link" (click)="openLearnMore($event)">
        {{ 'SHARED.COMPONENTS.AI_TEASER.LEARN_MORE' | translate }}
      </a>
    </div>
  `,
  styleUrl: './ai-upsell-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class AiUpsellPopoverComponent {
  private readonly intercomService = inject(IntercomService);

  protected openLearnMore(event: MouseEvent): void {
    this.intercomService.openArticleLink(event, AI_DISCLOSURE_ARTICLE_ID);
  }
}
